import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CssBaseline from "@material-ui/core/CssBaseline";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import { lightGreen } from '@material-ui/core/colors';
import {
  MuiPickersUtilsProvider,
  DatePicker
} from "material-ui-pickers";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 7,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  textField: {
    "&$cssFocused": {
      backgroundColor: "#FFFFFF"
    },
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    backgroundColor: "#EDEDED"
  },
  dense: {
    marginTop: 16
  },
  menu: {
    width: 200
  },
  grid: {
    width: "100%"
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  },
  binded: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    backgroundColor: lightGreen.A400
  }
});

class Signup extends Component {
  state = {
    lastname: "",
    firstname: "",
    phone: "",
    identity: "",
    height: "",
    weight: "",
    airbox: "",
    gender: "",
    dateofbirth: new Date(),
    deleteHealthDialog: false,
    deleteGarminDialog: false
  };

  handleDateChange = date => {
    this.setState({ dateofbirth: date });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  componentDidMount() {
    this.fetchUserInfo();
  }

  async fetchUserInfo() {
    try {
      const result = await fetch(`/api/user/info`, {
        mode: "cors",
        method: "GET"
      });

      const data = await result.json();

      this.setState({
        ...data
      });
    } catch (e) {
      console.log(e);
    }
  }

  deleteHealth = () => {
    this.setState({
      deleteHealthDialog: true
    });
  };

  deleteGarmin = () => {
    this.setState({
      deleteGarminDialog: true
    });
  };

  handleDeleteClose = () => {
    this.setState({ deleteHealthDialog: false, deleteGarminDialog: false });
  };

  render() {
    const { classes } = this.props;

    const { dateofbirth } = this.state;

    return (
      <main className={classes.main}>
        <CssBaseline />

        <Paper className={classes.paper}>
          <Typography component="h1" variant="h5">
            個人資料
          </Typography>

          <Typography variant="h5">{this.state.email}</Typography>

          <form method="post" className={classes.container} autoComplete="off">
            <TextField
              required
              fullWidth
              id="lastname"
              label="姓"
              placeholder="王"
              name="lastname"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={this.handleChange("lastname")}
              value={this.state.lastname}
            />

            <TextField
              required
              fullWidth
              id="firstname"
              label="名"
              placeholder="大明"
              name="firstname"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={this.handleChange("firstname")}
              value={this.state.firstname}
            />

            <TextField
              required
              fullWidth
              id="phone"
              label="手機"
              placeholder="0912345678"
              name="phone"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={this.handleChange("phone")}
              value={this.state.phone}
            />

            <TextField
              required
              fullWidth
              id="identity"
              label="身份證字號"
              name="identity"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={this.handleChange("identity")}
              value={this.state.identity}
            />

            <TextField
              required
              fullWidth
              id="height"
              label="身高"
              placeholder="177.7"
              name="height"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={this.handleChange("height")}
              value={this.state.height}
            />

            <TextField
              required
              fullWidth
              id="weight"
              label="體重"
              placeholder="77.2"
              name="weight"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={this.handleChange("weight")}
              value={this.state.weight}
            />

            <TextField
              fullWidth
              id="airbox"
              label="Airbox"
              name="airbox"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={this.handleChange("airbox")}
              value={this.state.airbox}
            />

            <TextField
              id="gender"
              select
              required
              label="性別"
              value={this.state.gender}
              onChange={this.handleChange("gender")}
              className={classes.textField}
              name="gender"
              SelectProps={{
                native: true,
                MenuProps: {
                  className: classes.menu
                }
              }}
              fullWidth
              margin="normal"
              variant="outlined"
            >
              <option />
              <option key="MALE" value="MALE">
                男
              </option>
              <option key="FEMALE" value="FEMALE">
                女
              </option>
            </TextField>

            <MuiPickersUtilsProvider
              utils={DateFnsUtils}
              className={classes.textField}
            >
              <Grid container className={classes.grid} justify="space-around">
                <DatePicker
                  margin="normal"
                  label="生日"
                  style={{ width: "88%" }}
                  className={classes.textField}
                  value={dateofbirth}
                  onChange={this.handleDateChange}
                />
              </Grid>
            </MuiPickersUtilsProvider>

            <Input
              type="hidden"
              id="dateofbirth"
              name="dateofbirth"
              value={dateofbirth}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              送出個人資料
            </Button>

            {this.state.garmin_id ? (
              <a style={{ width: "91%", textDecoration: "none" }}>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.binded}
                  onClick={this.deleteGarmin}
                >
                  已連接 Garmin
                </Button>
              </a>
            ) : (
              <a
                style={{ width: "91%", textDecoration: "none" }}
                href="/garmin//oauth2/authorize"
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  綁定 Garmin
                </Button>
              </a>
            )}

            {this.state.user_id || this.state.health_connected ? (
              <a style={{ width: "91%", textDecoration: "none" }}>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.binded}
                  onClick={this.deleteHealth}
                >
                  已連接 Google Health
                </Button>
              </a>
            ) : (
              <a
                style={{ width: "91%", textDecoration: "none" }}
                href="/health/authorize"
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  綁定 Google Health
                </Button>
              </a>
            )}

            <a style={{ width: "91%", textDecoration: "none" }} href="/logout">
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                登出
              </Button>
            </a>
          </form>
        </Paper>
        <Dialog
          open={this.state.deleteHealthDialog}
          onClose={this.handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <form method="post" action="/health/disconnect">
            <DialogTitle id="alert-dialog-title">
              是否要解除 Google Health 連結？
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                刪除後需要重新綁定裝置
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDeleteClose} color="primary">
                取消
              </Button>
              <Button
                onClick={this.handleDeleteClose}
                color="primary"
                type="submit"
                autoFocus
              >
                確認
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <Dialog
          open={this.state.deleteGarminDialog}
          onClose={this.handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <form method="post" action="/garmin/api/deleteGarmin">
            <Input
              type="hidden"
              id="user_id"
              name="user_id"
              value={this.state.user_id}
            />
            <DialogTitle id="alert-dialog-title">
              是否要刪除Garmin裝置？
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                刪除後需要重新綁定裝置
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDeleteClose} color="primary">
                取消
              </Button>
              <Button
                onClick={this.handleDeleteClose}
                color="primary"
                type="submit"
                autoFocus
              >
                確認
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </main>
    );
  }
}

Signup.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Signup);
